import React from "react";

import { UseFormReturn } from "react-hook-form";

import { Box, Typography } from "@mui/material";

import { Trans } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";
import { ZPlayLoader } from "commons";
import { ContentDescription, Series } from "models";
import { GetCollectionListResponse } from "models/response";
import { ThumbUpload, TitleAndSynopsisData } from "components/backoffice/content/create-and-edit-content-detail-form/metadata-section";
import SeriesDetailsData from "./series-details-data/series-details-data";
import { SeriesLanguageData } from "./series-language-data/series-language-data";

export interface SeriesMetadataSectionState {
    isLoading: boolean
}

export interface SeriesMetadataSectionProps {
    name: string
    fileImgName: string | null
    fileImgURL: any
    isThumbUploaded: boolean
    removeFileImg: () => void
    parseFileImg: (event: any) => void
    title: ContentDescription[]
    synopsis: ContentDescription[]
    updateTitleAndSynopsis: (title: ContentDescription[], synopsis: ContentDescription[]) => void
    collectionsList: GetCollectionListResponse
    series: Series | null
}

class SeriesMetadataSection extends React.Component<SeriesMetadataSectionProps & UseFormReturn & WithSnackbarProps, SeriesMetadataSectionState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    render() {
        return (<>
            <Typography
                color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}
                variant="h3"
                textAlign="center"
                mb={3}>
                <Trans id={"csf-metadata-section"}>Metadata</Trans>
            </Typography>
            <Typography
                mb={5}
                variant={"body2"}
                color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                <Trans id={"csf-metadata-info"}> Per poter creare una serie è necessario inserire almeno un titolo e una sinossi. È inoltre richiesto di inserire un'immagine di copertina. </Trans>
            </Typography>

            {/* UPLOAD ANTEPRIMA */}
            {<ThumbUpload
                fileImgName={this.props.fileImgName}
                fileImgURL={this.props.fileImgURL}
                isThumbUploaded={this.props.isThumbUploaded}
                removeFileImg={this.props.removeFileImg}
                parseFileImg={this.props.parseFileImg}
            />}

            {/* ACCORDION */}
            <Box sx={{ mt: 4 }}>
                <TitleAndSynopsisData
                    languageList={this.props.collectionsList.languageList.list}
                    {...this.props} />
                <SeriesDetailsData
                    {...this.props} />
                <SeriesLanguageData
                    languageList={this.props.collectionsList.languageList.list}
                    {...this.props} />
            </Box>

            {this.state.isLoading && <ZPlayLoader />}
        </>)
    }
}

export default withSnackbar(SeriesMetadataSection);